<template>
  <qx-card title="列表">
    <LogRightDialog ref="logRightDialog" busiCode="3000020" />
    <section slot="titleRight">
      <qx-permpisions permpisions="">
        <el-button type="primary" plain @click="() => toMaintenanceApply()">
          <i class="iconfont">&#xe6ab;</i>维保申请
        </el-button>
      </qx-permpisions>
      <qx-permpisions permpisions="">
        <el-button type="primary" plain @click="() => toCostApply()">
          <i class="iconfont">&#xe6ab;</i>费用申请
        </el-button>
      </qx-permpisions>
      <qx-permpisions permpisions="">
        <ExportBtn :len="tableData.data.length"
          queryUrl="repairPreApplyBO.ajax?cmd=doQueryPreList"
          :params="fullSearchData"
          bizName="维保申请数据导出"
          bizCode="exp100042"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
            :fixed="item.prop === 'applyCode'"
          >
            <section slot-scope="scope">
              <section
                v-if="scope.column.property === 'applyCode'"
                @click="toDetail(scope.row)"
              >
                <span class="primary cur">{{
                  scope.row[scope.column.property]
                }}</span>
              </section>
              <section v-if="scope.column.property !== 'applyCode'">
                {{ scope.row[scope.column.property] }}
              </section>
            </section>
          </el-table-column>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            width="140"
            fixed="right"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :isCenter="true"
                :btnList="[
                  {
                    showCondition: scope.row.isAudit === 1,
                    name: '审核',
                    event: () => toDetail(scope.row, 'approve'),
                  },
                  {
                    showCondition: true,
                    name: '修改',
                    event: () => toEdit(scope.row),
                  },
                  {
                    showCondition: scope.row.state < 6,
                    name: '取消',
                    event: () => cancel(scope.row.applyId),
                  },
                  {
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row.eid),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import ExportBtn from 'components/exportBtn';
import TableBtn from 'components/tableBtn/tableBtn';
import {
  maintenanceList,
  maintenanceCancel,
} from 'api/cost';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    ExportBtn,
    TableBtn,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'applyCode',
            label: '申请单号',
          },
          {
            prop: 'stateName',
            label: '状态',
          },
          {
            prop: 'applyUserName',
            label: '申请人',
          },
          {
            prop: 'applyTime',
            label: '申请时间',
          },
          {
            prop: 'feeApplyTime',
            label: '费用申请时间',
          },
          {
            prop: 'feeAscriptionDate',
            label: '费用归属日期',
          },
          {
            prop: 'preAmt',
            label: '预估费用',
          },
          {
            prop: 'transAmt',
            label: '维保费用',
          },
          {
            prop: 'applyTypeName',
            label: '费用类型',
          },
          {
            prop: 'feeExplain',
            label: '费用说明',
          },
          {
            prop: 'receName',
            label: '收款方',
          },
          {
            prop: 'receBankName',
            label: '收款银行',
          },
          {
            prop: 'receBankNo',
            label: '收款账号',
          },
          {
            prop: 'payoutId',
            label: '支付流水号',
          },
          {
            prop: 'orgName',
            label: '费用归属',
          },
          {
            prop: 'repairReson',
            label: '维修原因',
          },
          {
            prop: 'serviceName',
            label: '服务商',
          },
          {
            prop: 'productName',
            label: '服务商站点',
          },
          {
            prop: 'applyCount',
            label: '明细条数',
          },
          {
            prop: 'updateTime',
            label: '最新修改时间',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: maintenanceList,
    toEdit (item) {
      if (item.isPreApply === 0) { // 维保申请
        this.jump({
          label: (item ? '修改' : '新增') + '维保申请',
          url: `/manage/cost/car/apply/maintenanceApply${item ? '?id=' + item.eid : ''}`,
          full: true,
        });
      } else { // 费用申请
        this.jump({
          label: (item ? '修改' : '新增') + '费用申请',
          url: `/manage/cost/car/apply/costApply${item ? '?id=' + item.eid : ''}`,
          full: true,
        });
      }
    },
    toDetail (item, type = '') {
      if (item.isPreApply === 0) { // 维保申请
        this.jump({
          label: type ? '审核维保申请' : '维保申请详情',
          url: `/manage/cost/car/apply/maintenanceDetail?id=${item.eid}&type=${type}`,
          full: true,
        });
      } else { // 费用申请
        this.jump({
          label: type ? '审核费用申请' : '费用申请详情',
          url: `/manage/cost/car/apply/costDetail?id=${item.eid}&type=${type}`,
          full: true,
        });
      }
    },
    toMaintenanceApply () {
      this.jump({
        label: '新增维保申请',
        url: '/manage/cost/car/apply/maintenanceApply',
        full: true,
      });
    },
    toCostApply () {
      this.jump({
        label: '新增费用申请',
        url: '/manage/cost/car/apply/costApply',
        full: true,
      });
    },
    showLog (customerId) {
      this.$refs.logRightDialog.show(customerId);
    },
    async cancel (applyId) {
      const confirmRes = await this.$confirm('是否确定取消申请？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
        this.$message({
          type: 'info',
          message: '已取消操作',
        });
      });
      if (confirmRes === 'confirm') {
        const delRes = await maintenanceCancel({
          applyId,
        });
        if (!delRes.failed) {
          this.$message({
            type: 'success',
            message: '已成功取消',
          });
          this.getData();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
